module.exports = __webpack_public_path__ + "static/graph-year-5-2a16e823149dd472508da50fc0438e22.svg";